<template>
  <div>
    <v-layout align-center style="height: 80px;" class="pl-4 title">
      <span>个人车辆列表</span>
    </v-layout>
    <l-data-card
      class="px-2"
      :get-data="getItems"
      :headers="headers"
      clickable
      ref="vehicleList"
      @click:row="goDetails($event.item)"
    >
      <template slot="item-action" slot-scope="{props}">
        <v-layout justify-center @click.stop>
          <v-btn color="primary" flat @click="deleteVehicleConfirm(props.item)">解除绑定</v-btn>
        </v-layout>
      </template>
    </l-data-card>
  </div>
</template>

<script>
import LDataCard from '@/components/LDataCard'

const reviewStatus = {
  '0': '待审核',
  '1': '审核通过',
  '2': '审核拒绝'
}
export default {
  name: 'myVehicleList',
  components: {LDataCard},
  data: vm => ({
    headers: [
      {text: '车辆号牌', value: 'plate', align: 'left'},
      {text: '注册时间', value: 'creationTime', f: v => vm.$L.time.stringify(v), align: 'left'},
      {text: '审核状态', value: 'status', f: v => reviewStatus[v], align: 'left'}
    ]
  }),
  methods: {
    getItems ({pagination}) {
      return this.$store.dispatch('pass/getVehicles', {
        pagination,
        self: true
      })
    },
    async goDetails (item) {
      try {
        let {items} = await this.$store.dispatch('pass/searchVehicles', {plate: item.plate})
        if (items.length) {
          this.$router.push({
            name: 'VehicleDetailsWX',
            params: {
              plate: items[0].plate,
              vehicle: items[0]
            }
          })
        }
        else {
          throw Error('未找到该车辆')
        }
      }
      catch (e) {
        this.$L.error(e.message)
      }
    },
    async deleteVehicleConfirm (item) {
      console.log(item)
      let {res, close} = await this.$L.confirm({
        title: '删除确认',
        text: '是否删除该车辆，车牌：' + item.plate
      })
      if (res) {
        try {
          this.deleteVehicle(item,false)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteVehicle (item,status) {
      let ids = []
      ids.push(item.id)
      console.log(ids)
      let res = await this.$store.dispatch('vehicleRegister/deleteVehicles', {ids:ids,status:status})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '解绑成功'})
      }
      else {
        this.$L.alert('error',{message:"删除失败,原因:"+res.data.msg})
      }
    }
  },
  created () {
    this.$store.dispatch('login/initControllers')
  }
}
</script>

<style scoped>

</style>
